
import {
  Vue,
  Component,
  Prop,
  Watch,
  Model,
  Emit,
} from 'vue-property-decorator';
import SPUService from '@/services/spu.service';
import lazyInject from '@/di';

@Component
export default class NoticeInfosField extends Vue {
  val: any[] = [];

  @Prop()
  form!: any;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  refs!: any;

  @Prop()
  noticeInfosType!: boolean;

  @Model()
  value!: any[];

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  onlyType = true;

  @Watch('value')
  async watchValue() {
    if (this.noticeInfosType) {
      if (this.value && this.value.length) {
        this.val = [...this.value];
      } else {
        this.val = [];
      }
    } else {
      const { id } = this.form;
      if (!id) {
        this.getNoticeInfos();
      } else if (this.value && this.value.length) {
        this.val = [...this.value];
      } else {
        this.getNoticeInfos();
      }
    }
  }

  async getNoticeInfos() {
    console.log('初始化');
    if (this.onlyType) {
      const res = await this.spuService.postSpuNoticeInfo();
      // console.log(res);
      const resultString = res.map((item: any) => ({
        ...item,
        remarks: item.remarks.join('\n'),
      }));
      this.val = resultString;
      this.updateVal();
      this.onlyType = false;
    }
  }

  // async watchValue() {
  //   console.log(this.form);
  //   const { id } = this.form;
  //   if (!id) {
  //   }
  // }

  @Emit('update')
  updateVal() {
    return this.val;
  }

  mounted() {
    this.watchValue();
  }
}
